import GoodCompany from "./goodCompany/GoodCompany";
import './sidebar.scss';
import CallUs from "./callUs/CallUs";
import CoverRequirements from "./coverRequirements/CoverRequirements";
import { IsWebReference } from "../../functions/Configuration";
import QuoteTime from "./quoteTime/QuoteTime";
import FreeToUse from "./freeToUse/FreeToUse";
import Awards from "./awards/Awards";

export default function Sidebar(props: any) {

    return (
        <div className="sidebar">
            <span className="sidebar-container">
                {props.page < 4 &&
                    <>
                        <GoodCompany />
                        <QuoteTime />
                        <FreeToUse />
                    </>
                }
                {props.page === 4 && !IsWebReference("SC") && localStorage.getItem("questions") != null &&
                    <>
                        <CoverRequirements />
                    </>
                }
                <CallUs />
            </span>
            <Awards />
        </div>
    )
}